/**
 * Format helpers
 */
export function fmtCurrency(v, currency = "IDR") {
  if (v == null || isNaN(v)) return "—";
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) return `${(v / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${(v / 1_000).toFixed(1)}K`;
  return v.toLocaleString();
}

export function fmtFullCurrency(v, currency = "IDR") {
  if (v == null || isNaN(v)) return "—";
  return `${currency} ${Math.round(v).toLocaleString()}`;
}

export function fmtPercent(v, digits = 2) {
  if (v == null || isNaN(v)) return "—";
  return `${Number(v).toFixed(digits)}%`;
}

export function fmtNumber(v, digits = 0) {
  if (v == null || isNaN(v)) return "—";
  return Number(v).toLocaleString(undefined, { maximumFractionDigits: digits });
}

/**
 * Format a raw numeric value as a thousand-separated display string.
 * Accepts numbers or numeric strings (with or without existing separators).
 * Returns "" for null/undefined/empty/invalid input.
 *
 * Example: 7757400000 -> "7,757,400,000"
 */
export function formatNumberWithSeparator(value) {
  if (value === null || value === undefined || value === "") return "";
  const cleaned = String(value).replace(/,/g, "");
  if (cleaned === "" || cleaned === "-") return cleaned;
  // Allow a trailing "." while user is typing a decimal
  if (/^-?\d+\.$/.test(cleaned)) {
    const [intPart] = cleaned.split(".");
    const n = Number(intPart);
    if (!Number.isFinite(n)) return "";
    return `${n.toLocaleString("en-US")}.`;
  }
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return "";
  // Preserve decimal precision the user typed
  if (cleaned.includes(".")) {
    const [intPart, decPart] = cleaned.split(".");
    const intNum = Number(intPart || "0");
    return `${intNum.toLocaleString("en-US")}.${decPart}`;
  }
  return n.toLocaleString("en-US");
}

/**
 * Strip thousand separators and return a clean numeric string (or "").
 * Use this before sending to API / storing in DB / running calculations.
 *
 * Example: "7,757,400,000" -> "7757400000"
 */
export function parseFormattedNumber(value) {
  if (value === null || value === undefined || value === "") return "";
  return String(value).replace(/,/g, "");
}
